import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-cream py-16 sm:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Opening Statement */}
        <div className="mb-10 sm:mb-16 text-center">
          <h2 className="font-display text-2xl sm:text-4xl md:text-5xl font-black text-leather-dark mb-6 sm:mb-8 leading-tight italic">
            {t('about.quote1')}
          </h2>
          <div className="w-16 sm:w-24 h-1 bg-orange-burnt mx-auto"></div>
        </div>

        {/* Body Text */}
        <div className="space-y-6 sm:space-y-8 text-center">
          <p 
            className="font-display text-base sm:text-xl md:text-2xl text-leather-dark/80 leading-relaxed italic"
            dangerouslySetInnerHTML={{ __html: t('about.paragraph1') }}
          />

          <p 
            className="font-display text-base sm:text-xl md:text-2xl text-leather-dark/80 leading-relaxed italic"
            dangerouslySetInnerHTML={{ __html: t('about.paragraph2') }}
          />

          <p 
            className="font-display text-base sm:text-xl md:text-2xl text-leather-dark/80 leading-relaxed italic"
            dangerouslySetInnerHTML={{ __html: t('about.paragraph3') }}
          />

          <p className="font-display text-xl sm:text-2xl md:text-3xl text-orange-burnt font-black leading-relaxed italic">
            {t('about.quote2')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
